module.exports = __webpack_public_path__ + "img/kw.f1e7ade2.svg";